import BaseMessage from '../BaseMessage';

class Subscription extends BaseMessage {
  constructor(params) {
    super();
    this.method = 'blade.subscription';

    if (params.hasOwnProperty('auto_create') && !params.auto_create) {
      delete params.auto_create;
    }

    if (params.hasOwnProperty('downstream') && !params.downstream) {
      delete params.downstream;
    }

    this.buildRequest({
      method: this.method,
      params
    });
  }

}

export { Subscription };